<template>
  <base-layout>
    <h1 slot="header">
      {{ `app.pages.settings.profile` | trans }}
    </h1>
    <v-alert v-if="sharingAcceptanceStatus === 'permissions'" :value="true" :type="`error`" class="mt-4" :dismissible="true"
    v-html="`<span>` + trans('app.no_access_tooltip')+ `</span>`">
    </v-alert>
    <v-app id="vuetify-app">
      <v-container fluid>
        <v-layout row wrap align-start justify-left>
          <v-flex sm3>
            <settings-category
                :url="routes.subscription"
                :icon="`local_grocery_store`"
                :title="`app.pages.settings.subscription` | trans"
                :description="`app.pages.settings.subscription_desc` | trans"
            ></settings-category>
          </v-flex>
          <v-flex sm3>
            <settings-category
                :url="routes.orders_and_invoices"
                :icon="`credit_card`"
                :title="`app.pages.settings.orders_and_invoices` | trans"
                :description="`app.pages.settings.orders_and_invoices_desc` | trans"
            ></settings-category>
          </v-flex>
          <v-flex sm3>
            <settings-category
                :url="routes.appearance"
                :icon="`format_paint`"
                :title="`app.pages.settings.appearance` | trans"
                :description="`app.pages.settings.appearance_desc` | trans"
            ></settings-category>
          </v-flex>
          <v-flex sm3>
            <settings-category
                :url="routes.printing"
                :icon="`print`"
                :title="`app.pages.settings.printing` | trans"
                :description="`app.pages.settings.printing_desc` | trans"
            ></settings-category>
          </v-flex>
          <v-flex sm3>
            <settings-category
                :url="routes.profile"
                :icon="`account_circle`"
                :title="`app.pages.settings.your_account` | trans"
                :description="`app.pages.settings.profile_desc` | trans"
            ></settings-category>
          </v-flex>
          <v-flex sm3>
            <settings-category
                :url="routes.tags"
                :icon="`label`"
                :title="`app.pages.settings.tags` | trans"
                :description="`app.pages.settings.tags_desc` | trans"
            ></settings-category>
          </v-flex>
          <v-flex sm3>
            <settings-category
                :url="routes.rodo"
                :icon="`description`"
                :title="`app.pages.settings.arrangement_rodo` | trans"
                :description="`app.pages.settings.arrangement_rodo_desc` | trans"
            ></settings-category>
          </v-flex>
          <v-flex sm3>
            <settings-category
                :url="routes.sharing"
                :permission="`sharing_list`"
                :icon="`share`"
                :title="`app.pages.settings.sharing.title` | trans"
                :description="`app.pages.settings.sharing.description` | trans"
            ></settings-category>
          </v-flex>
        </v-layout>
      </v-container>
    </v-app>
  </base-layout>
</template>

<script>
export default {
  props: {
    routes: Object,
    sharingAcceptanceStatus: {
      type: String,
      required: false,
      default: null,
    },
  }
};
</script>
